import React, { useState } from 'react'
import classNames from 'classnames'
import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'
import ExperienceCopyModal from './ExperienceCopyModal'

const isSelectedOption = (value) =>
  Boolean(
    value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      (value.value || value.label),
  )

const QuestCopySelection = ({
  name,
  placeholder,
  disabled,
  label,
  isDiscardLabelPadding,
  currentQuestId,
  onQuestSelected,
  onClear,
  modalTitle,
  modalLead,
  triggerClassName,
}) => {
  const formik = useFormikContext()
  const [showModal, setShowModal] = useState(false)
  const [selectedLabel, setSelectedLabel] = useState('')

  const selectedValue = name && formik ? formik.values?.[name] : null
  const hasSelection = Boolean(selectedLabel || isSelectedOption(selectedValue))
  const displayText = selectedValue?.label || selectedLabel || placeholder

  const handleOpen = () => {
    if (!disabled) {
      setShowModal(true)
    }
  }

  const handleClose = () => {
    setShowModal(false)
  }

  const handleSelect = (selectedOption) => {
    if (name && formik) {
      formik.setFieldValue(name, selectedOption, true)
    }
    setSelectedLabel(selectedOption?.label || '')
    setShowModal(false)
    if (onQuestSelected) {
      onQuestSelected(selectedOption)
    }
  }

  const handleClear = () => {
    if (name && formik) {
      formik.setFieldValue(name, null, true)
    }
    setSelectedLabel('')
    if (onClear) {
      onClear()
    }
  }

  return (
    <div className='experience-copy-selection'>
      {label ? (
        <span
          className={classNames('experience-f-label', {
            'px-0': isDiscardLabelPadding,
          })}>
          {label}
        </span>
      ) : null}
      <button
        type='button'
        className={classNames(
          'experience-search experience-itin-copy-trigger',
          triggerClassName,
          { 'has-value': hasSelection },
        )}
        onClick={handleOpen}
        disabled={disabled}
        aria-haspopup='dialog'>
        <span className='experience-itin-copy-label'>{displayText}</span>
        <span className='experience-itin-copy-caret' aria-hidden='true'>
          ▾
        </span>
      </button>
      {hasSelection && !disabled ? (
        <button
          type='button'
          className='experience-muted-btn experience-copy-clear'
          onClick={handleClear}>
          Clear
        </button>
      ) : null}

      <ExperienceCopyModal
        show={showModal}
        onHide={handleClose}
        onSelect={handleSelect}
        currentQuestId={currentQuestId}
        title={modalTitle}
        lead={modalLead}
      />
    </div>
  )
}

QuestCopySelection.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  isDiscardLabelPadding: PropTypes.bool,
  currentQuestId: PropTypes.string,
  onQuestSelected: PropTypes.func,
  onClear: PropTypes.func,
  modalTitle: PropTypes.string,
  modalLead: PropTypes.string,
  triggerClassName: PropTypes.string,
}

QuestCopySelection.defaultProps = {
  placeholder: 'Select experience to copy from…',
  disabled: false,
  label: '',
  isDiscardLabelPadding: false,
  currentQuestId: null,
  onQuestSelected: null,
  onClear: null,
  modalTitle: 'Copy from another experience',
  modalLead:
    'Choose an experience to copy content from. Dates, leaders and the roster stay unique to this experience.',
  triggerClassName: '',
}

export default QuestCopySelection
